document.getElementById('Details-menu-drawer-container-close-button').addEventListener('click', function (e) {
  const menuDrawer = document.getElementById('Details-menu-drawer-container');
  menuDrawer.classList.remove('menu-opening');
  setTimeout(function () {
    menuDrawer.removeAttribute('open');
  }, 200);
  const menuIcon = document.getElementsByClassName('header__icon--summary')[0];
  menuIcon.setAttribute('aria-expanded', 'false');
  const headerSection = document.getElementsByClassName('shopify-section-header-sticky');
  headerSection[0].classList.remove('menu-open');
  document.body.classList.remove('overflow-hidden-tablet');
  document.body.classList.remove('gradient');
});

window.addEventListener('popstate', () => {
  const menuDrawer = document.getElementById("Details-menu-drawer-container");
  menuDrawer.classList.remove("menu-opening");
  setTimeout(function () {
    menuDrawer.removeAttribute("open");
  }, 200);
  const menuIcon = document.getElementsByClassName(
    "header__icon--summary"
  )[0];
  menuIcon.setAttribute("aria-expanded", "false");
  const headerSection = document.getElementsByClassName(
    "shopify-section-header-sticky"
  );
  headerSection[0].classList.remove("menu-open");
  document.body.classList.remove("overflow-hidden-tablet");
  document.body.classList.remove("gradient");
});


const ecLaguageSelector = document.getElementById('ec-language-selector');
const ecLaguageSelectorHeader = document.getElementById('ec-language-selector-header');

ecLaguageSelector.addEventListener('click', function (e) {
  addShowLanguages(e.currentTarget);
});

window.addEventListener('click', function(e) {
  if (!ecLaguageSelectorHeader.contains(e.target)) {
    ecLaguageSelectorHeader.parentElement.children[1].classList.add('ec-hidden');
  }
});

ecLaguageSelectorHeader.addEventListener('click', function (e) {
  addShowLanguages(e.currentTarget);
});

const addShowLanguages = (element) => {
  if (element.parentElement.children[1].classList.contains('ec-hidden')) {
    element.parentElement.children[1].classList.remove('ec-hidden');
  } else {
    element.parentElement.children[1].classList.add('ec-hidden');
  }
  if (element.children.length === 0) return;
};

const ecLaguageSelectorDesktop = document.getElementById('ec-language-selector-desktop');
const ecLaguageSelectorDesktopMenu = document.getElementById('ec-language-selector-desktop-menu');

ecLaguageSelectorDesktop.addEventListener('click', function (e) {
  addShowLanguages(e.currentTarget);
});

window.addEventListener('click', function(e){
  if (!ecLaguageSelectorDesktopMenu.contains(e.target) && (!ecLaguageSelectorDesktop.contains(e.target))) {
    ecLaguageSelectorDesktopMenu.classList.add('ec-hidden');
  } 
});

const ecAccountSelector = document.getElementById('ec-account-selector');
const ecAccountSelectorMenu = document.getElementById('ec-account-menu');

ecAccountSelector.addEventListener('click', function (e) {
  const ecAccountMenu = document.getElementById('ec-account-menu');

  ecAccountMenu.classList.toggle('ec-hidden');
});

window.addEventListener('click', function(e){
  if (!ecAccountSelectorMenu.contains(e.target) && (!ecAccountSelector.contains(e.target))) {
    ecAccountSelectorMenu.classList.add('ec-hidden');
  } 
});

const headerMenuDesktopItems = document.getElementsByClassName('mega-menu');
const headerMenuDesktopItemsArray = Array.from(headerMenuDesktopItems);
headerMenuDesktopItemsArray.forEach((item) => {
  item.addEventListener('mouseover', function (e) {
    e.currentTarget.setAttribute('open', true);
  });
  item.addEventListener('mouseleave', function (e) {
    e.currentTarget.removeAttribute('open');
  });
});

const setLanguageSwicherLanguage = () => {
  console.log('window.location', window.location.hostname);
  const hostname = window.location.hostname;
  const english = document.querySelectorAll('.language.english');
  const german = document.querySelectorAll('.language.german');
  const french = document.querySelectorAll('.language.french');
  if (hostname === '127.0.0.1' || hostname === 'nikinclothing.com') {
    english.forEach((item) => {
      item.classList.add('ec-hidden');
    });
    german.forEach((item) => {
      item.classList.remove('ec-hidden');
    });
    french.forEach((item) => {
      item.classList.add('ec-hidden');
    });
  } else if (hostname === 'fr.nikinclothing.com') {
    english.forEach((item) => {
      item.classList.add('ec-hidden');
    });
    german.forEach((item) => {
      item.classList.add('ec-hidden');
    });
    french.forEach((item) => {
      item.classList.remove('ec-hidden');
    });
  } else if (hostname === 'en.nikinclothing.com') {
    english.forEach((item) => {
      item.classList.remove('ec-hidden');
    });
    german.forEach((item) => {
      item.classList.add('ec-hidden');
    });
    french.forEach((item) => {
      item.classList.add('ec-hidden');
    });
  }
};

setLanguageSwicherLanguage();
